import { TextDisplay } from '@i18nspect/types';
import i18next from 'i18next';
var _appI18n = null;
var _interceptorI18n = i18next.createInstance();
_interceptorI18n.init({
    resources: {},
    saveMissing: false,
    defaultNS: false,
    fallbackNS: false,
});
var _display = TextDisplay.Language;
var _slardar = null;
var _tea = null;
var _btm = null;
var _enableInspect = false;
var _namespaceMap = {};
export default {
    get display() {
        return _display;
    },
    set display(value) {
        _display = value;
    },
    get enableInspect() {
        return _enableInspect;
    },
    set enableInspect(value) {
        _enableInspect = value;
    },
    setAppI18n: function (instance) {
        _appI18n = instance;
    },
    getAppI18n: function () {
        return _appI18n;
    },
    getInterceptorI18n: function () {
        return _interceptorI18n;
    },
    get slardar() {
        return _slardar;
    },
    set slardar(val) {
        _slardar = val;
    },
    get tea() {
        return _tea;
    },
    set tea(val) {
        _tea = val;
    },
    get btm() {
        return _btm;
    },
    set btm(val) {
        _btm = val;
    },
    get namespaceMap() {
        return _namespaceMap;
    },
    set namespaceMap(obj) {
        _namespaceMap = obj;
    },
};
